import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, X } from "lucide-react";
import { api } from "@/lib/api";
import Countdown from "@/components/Countdown";

export default function SaleBanner({ placement }) {
  const [b, setB] = useState(null);
  const [hidden, setHidden] = useState(sessionStorage.getItem(`lx_sale_hide_${placement}`) === "1");
  const load = () => api.get("/public/sale-banner").then((r) => setB(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (hidden || !b?.active || !b.show_on.includes(placement)) return null;
  const close = () => { sessionStorage.setItem(`lx_sale_hide_${placement}`, "1"); setHidden(true); };
  return (
    <div className="relative flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-rose-500/30 bg-gradient-to-r from-rose-50 to-amber-50 px-4 py-3 pr-10 mb-6" data-testid={`sale-banner-${placement}`}>
      <Flame className="h-5 w-5 text-rose-600 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-bold" style={{ color: "#0F172A" }} data-testid="sale-banner-title">{b.title}</div>
        {b.message && <div className="text-sm" style={{ color: "#334155" }} data-testid="sale-banner-message">{b.message}</div>}
        <Countdown until={b.ends_at} testid="sale-banner-countdown" onEnd={load} />
      </div>
      <Link to={placement === "home" ? "/register" : "/billing"} className="self-start sm:self-center px-4 py-2 rounded-full bg-rose-600 text-white text-sm font-semibold hover:bg-rose-700 transition-colors whitespace-nowrap" data-testid="sale-banner-cta">{b.cta_label}</Link>
      <button type="button" onClick={close} className="absolute top-2 right-2 p-1 text-slate-400 hover:text-slate-700" aria-label="Dismiss" data-testid="sale-banner-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
}
